import PropTypes from 'prop-types';
import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { finishSubscription, reviveSubscription } from '~/actions/subscriptions'

import TextLoader from '~/components/Loaders/TextLoader'


class Subscription extends React.Component {

    cancelSubscription = (date) => {
		var date = moment.unix(date).format('MMMM Do YYYY'),
			conf = window.confirm('Doing this will close your Five to Nine Club account on ' + date + '. Are you sure you want to cancel?')
		if( conf ) {
			this.props.finishSubscription()
		}
	};

    reviveSubscription = (date) => {
		var date = moment.unix(date).format('MMMM Do YYYY'),
			conf = window.confirm('Your subscription will continue and you will be charged on ' + date + '. Are you happy to proceed?')
		if( conf ) {
			this.props.reviveSubscription()
		}
	};

    render() {

		var { session } = this.props;

		if( !session.subscription || !('id' in session.subscription) ) return null;
		if( !!this.props.fetching ) return <TextLoader classes="mtop30 mbot30" />

		var { subscription } = session,
			cancelled = subscription.status === 'cancelled' || !!subscription.end_date,
			price = subscription.plan.price / 100,
			date = cancelled ? subscription.end_date : subscription.next_date;

		return !cancelled
			? <p className="text-center small text-dark-grey mtop30 mbot30">
				Your next payment of £{price} will be taken on { moment.unix(date).format('MMMM Do YYYY') }.
				You can <a href="javascript:void(0);" onClick={this.cancelSubscription.bind(this, date)}>cancel your subscription here</a>.
			</p>
			: <p className="text-center small text-dark-grey mtop30 mbot30">
				Your subscription will be cancelled and your account closed on { moment.unix(date).format('MMMM Do YYYY') }.
				You can <a href="javascript:void(0);" onClick={this.reviveSubscription.bind(this, date)}>revive your subscription here</a>.
			</p>

	}
}

const mapStateToProps = state => ({
    session: state.session,
    fetching: state.session.fetching.subscription,
});

const mapDispatchToProps = dispatch => bindActionCreators({ finishSubscription, reviveSubscription }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Subscription);




// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Subscription.jsx